import { constants } from "./constants";
import MapTemplate from "../../template";

export default function ReddaiMap() {
    return <MapTemplate constants={constants} />;
}

